import { render, staticRenderFns } from "./ProcessingQueue.vue?vue&type=template&id=5dfe3e3f&scoped=true"
import script from "./ProcessingQueue.vue?vue&type=script&lang=ts"
export * from "./ProcessingQueue.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfe3e3f",
  null
  
)

export default component.exports